/**
 * LE FORMAT D'AFFICHAGE D'UN NOM : « Jean-Pierre DUPONT ».
 *
 * ⚠️ AFFICHAGE SEULEMENT. Ce qui part à l'API et ce qui est stocké ne passe jamais par
 * ici : la saisie de la personne reste telle qu'elle l'a écrite.
 */

/** Prénom : majuscule à chaque mot (espace, tiret, apostrophe), le reste en minuscules. */
export function formatFirstName(value: unknown): string {
  if (typeof value !== "string") return "";
  return value
    .trim()
    .toLocaleLowerCase()
    .replace(/(^|[\s\-'’])(\p{L})/gu, (_, sep: string, letter: string) => sep + letter.toLocaleUpperCase());
}

/** Nom : tout en majuscules, particules et noms composés compris. */
export function formatLastName(value: unknown): string {
  return typeof value === "string" ? value.trim().toLocaleUpperCase() : "";
}

/** « Prénom NOM », sans trou si l'un des deux manque. */
export function formatFullName(firstName: unknown, lastName: unknown): string {
  return [formatFirstName(firstName), formatLastName(lastName)].filter(Boolean).join(" ");
}
